module.exports = __webpack_public_path__ + "fonts/fa-v2-solid-900.3e9b250e.woff";